import { Airport } from './Airport';
import { Administrator } from './Administrator';

export class  TransientObject {
    administrator: Administrator;
    airportList: Airport[];    
    allAirportList: Airport[];    
}